import { Mutation } from '../types';

export default {
  [Mutation.SET_USER](state, user) {
    state.user.first_name = user.first_name;
    state.user.last_name = user.last_name;
    state.user.phone = user.phone;
    state.user.email = user.email;

    state.loaded = true;
  },
  [Mutation.SET_ORGANISATION](state, organisation) {
    state.organisation.name = organisation.description;
  },
  [Mutation.SET_SUBSCRIPTION](state, subscription) {
    state.subscription.code = subscription.code
    state.subscription.description = subscription.description
    state.subscription.visit = subscription.has_service_visit
  },
};
